import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';

export function Breadcrumb({ itens }) {
    return (
        <nav aria-label="Você está em" className="hero-bread">
            <ol>
                {itens.map((item, i) => (
                    <li key={item.to || item.texto}>
                        {item.to && i < itens.length - 1 ? (
                            <Link to={item.to}>{item.texto}</Link>
                        ) : (
                            <span aria-current="page">{item.texto}</span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}

function Hero({ eyebrow, titulo, sub, breadcrumb, children }) {
    return (
        <section className="hub-hero">
            <Container>
                <div className="hub-hero__inner">
                    {breadcrumb && <Breadcrumb itens={breadcrumb} />}
                    {eyebrow && <p className="hub-hero__eyebrow">{eyebrow}</p>}
                    <h1 className="hub-hero__titulo">{titulo}</h1>
                    {sub && <p className="hub-hero__sub">{sub}</p>}
                    {children}
                </div>
            </Container>
        </section>
    );
}

export default Hero;
